import mod from "../lib/index.js";

export default mod["default"];
export const UX_GROWL_DELAY_MS = mod.UX_GROWL_DELAY_MS;
